exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Tab__tab___3ffRG {\n  display: flex;\n  flex-direction: column; }\n  .Tab__tab___3ffRG .Tab__tabOptions___c1rPQ {\n    display: flex;\n    margin: 0;\n    padding: 0;\n    list-style-type: none;\n    border-bottom: 1px solid #D9D9D9;\n    flex-shrink: 0; }\n    .Tab__tab___3ffRG .Tab__tabOptions___c1rPQ li {\n      margin: 0;\n      padding: 15px;\n      flex-grow: 1;\n      text-align: center;\n      cursor: pointer;\n      font-size: 1.2em;\n      color: #6b6767; }\n      .Tab__tab___3ffRG .Tab__tabOptions___c1rPQ li.Tab__active___fjdO_ {\n        border-bottom: 4px solid #50E3C2; }\n  .Tab__tab___3ffRG .Tab__activeTab___2IUcQ {\n    display: flex;\n    flex-direction: column; }\n", ""]);

// exports
exports.locals = {
	"tab": "Tab__tab___3ffRG",
	"tabOptions": "Tab__tabOptions___c1rPQ",
	"active": "Tab__active___fjdO_",
	"activeTab": "Tab__activeTab___2IUcQ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/components/Tab/Tab.scss
// module id = 703
// module chunks = 0